import { DebtMetricCardProps } from '../../types/debt.type';
import DebtMetricCard from './debtMetricCard';

const HEADLINE_COLUMNS = 2;
const TILE_COLUMNS = 3;

export default function DebtGrid({ data }: { data: DebtMetricCardProps[]; }) {
  const headlines = data.slice(0, HEADLINE_COLUMNS);
  const rowData = data.slice(HEADLINE_COLUMNS);
  const slicedRows = [...Array(Math.ceil(rowData.length / TILE_COLUMNS)).keys()].map((index) => (
    rowData.slice(index * TILE_COLUMNS, (index + 1) * TILE_COLUMNS)
  ));
  return (
    <div className="grid-container">
      <div id="grid-top-row-container" className="flex items-stretch">
        {headlines.map((headline, index) => (
          <div key={headline.label} className={`grid-tile-container ${index < headlines.length - 1 ? 'border-r border-pipgrey-border' : ''}`}>
            <DebtMetricCard
              value={headline.value}
              label={headline.label}
              filters={headline.filters}
              variance={headline.variance}
              trendUp={headline.trendUp}
            />
          </div>
        ))}
      </div>

      {slicedRows.map((row) => (
        <div key={row.map(({ label }) => label).join('-')} className="grid-columns-2-3">
          {row.map((tile, index) => (
            <div key={tile.label} className={`grid-tile-container ${index < row.length - 1 ? 'border-r border-pipgrey-border' : ''}`}>
              <DebtMetricCard
                value={tile.value}
                label={tile.label}
                filters={tile.filters}
                variance={tile.variance}
                trendUp={tile.trendUp}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
